import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { RateItem } from '../../types';
import { exchangeRatesApi } from '../services';

export interface RateListState {
  requestInProgress: boolean;
  selectedDate?: string;
  rates?: RateItem[];
  pagination?: Pagination;
  errorsList?: string;
}

const initialState: RateListState = {
  requestInProgress: false,
  selectedDate: undefined,
};

export const rateListSlice = createSlice({
  name: 'rateList',
  initialState,
  reducers: {
    onFilterByDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
    clearRateListState: (state) => {
      state.requestInProgress = false;
      state.rates = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeRatesApi.endpoints.getExchangeRates.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.getExchangeRates.matchRejected,
      (state, action: any) => {
        state.rates = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.getExchangeRates.matchFulfilled,
      (state, action: PayloadAction<Response<RateItem>>) => {
        state.rates = action.payload.data.edges.map((item) => ({
          ...item.node,
          description: `${item.node.currencyLeftName} - ${item.node.currencyRightName}`,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      exchangeRatesApi.endpoints.updateRate.matchFulfilled,
      (state, action: PayloadAction<{ data: RateItem }>) => {
        const nextRates = state.rates?.map((item) => {
          const result = { ...item };

          if (result.id === action.payload.data.id) {
            result.value = action.payload.data.value;
          }

          return result;
        });

        state.rates = nextRates;
      },
    );
  },
});

export const { onFilterByDate, clearRateListState } = rateListSlice.actions;

export default rateListSlice.reducer;
